import HTTP from '@api';

import { generateXHRError } from '@helpers';

export default {
  namespaced: true,
  state: {
    plugins: [],
    pluginByVendor: {},
  },
  mutations: {
    setPlugins(state, payload) {
      state.plugins = payload;
    },
    setPluginByVendor(state, payload) {
      state.pluginByVendor = payload;
    },
  },
  actions: {
    async getAllPlugins(
      { commit, rootState: { locations } },
      { suffix = locations.suffix } = {},
    ) {
      try {
        const { data } = await HTTP.get(`${suffix}/plugin`);
        commit('setPlugins', data || []);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async getPluginByVendor(
      { commit, rootState: { locations } },
      { suffix = locations.suffix, vendor },
    ) {
      try {
        const { data } = await HTTP.get(`${suffix}/plugin/${vendor}`);
        commit('setPluginByVendor', data || {});
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },

    async updatePlugin({ rootState: { locations } }, {
      suffix = locations.suffix, vendor, settings,
    }) {
      try {
        await HTTP.post(`${suffix}/plugin/${vendor}`, settings);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },
  },
};
